module.exports = __webpack_public_path__ + "img/alpha4.f107fcbe.png";